"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var ProductItem = /*#__PURE__*/function (_Vue) {
  function ProductItem() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductItem, [].concat(args));
    (0, _defineProperty2.default)(_this, "product", void 0);
    (0, _defineProperty2.default)(_this, "onDetail", void 0);
    (0, _defineProperty2.default)(_this, "onChangePriority", void 0);
    (0, _defineProperty2.default)(_this, "onStar", void 0);
    (0, _defineProperty2.default)(_this, "onDelete", void 0);
    (0, _defineProperty2.default)(_this, "visibleControl", void 0);
    return _this;
  }
  (0, _inherits2.default)(ProductItem, _Vue);
  return (0, _createClass2.default)(ProductItem);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductItem.prototype, "product", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductItem.prototype, "onDetail", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductItem.prototype, "onChangePriority", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductItem.prototype, "onStar", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductItem.prototype, "onDelete", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: true
})], ProductItem.prototype, "visibleControl", void 0);
ProductItem = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ProductItem);
var _default = exports.default = ProductItem;